import React from 'react';
import Icon from '../../../components/AppIcon';
import Input from '../../../components/ui/Input';

const SearchBar = ({ searchTerm, onSearchChange }) => {
  return (
    <div className="relative">
      <div className="absolute left-3 top-1/2 -translate-y-1/2 pointer-events-none">
        <Icon name="Search" size={20} className="text-muted-foreground" />
      </div>
      <Input
        type="search"
        placeholder="Rechercher par nom, ID ou contact..."
        value={searchTerm}
        onChange={(e) => onSearchChange(e?.target?.value)}
        className="pl-10"
      />
    </div>
  );
};

export default SearchBar;